<gp-modal #imageUploadModal [closable]="true">
  <div class="gp-modal-title">
    {{ title | translate }}
  </div>
  <div class="gp-modal-body">
    <div class="image-preview-container flex-center-x-y p-y-2">
      <div [attr.data-hidden]="!isInitialPreview && !isImageSelectedForDelete">
        <img *ngIf="hasImageToPreview else defaultImagePlaceholder"
             class="cr-image"
             [src]="photoLink"
             alt="preview of current image"
             width="200"
             height="200"/>
        <ng-template #defaultImagePlaceholder>
          <skeleton-image [width]="200" [height]="200" borderRadius="4"></skeleton-image>
        </ng-template>
      </div>

      <div [attr.data-hidden]="!isImageSelectedForUpload">
        <gp-image-cropper #cropper
                          *ngIf="isCropperEnabled else previewWithoutCropper"
                          [file]="imageForUpload"
                          [sizes]="imageSize"></gp-image-cropper>
        <ng-template #previewWithoutCropper>
          <img *ngIf="imgUrl else showDefaultPlaceholder"
               [src]="imgUrl"
               alt="preview without cropper"
               width="200"
               height="200"/>
          <ng-template #showDefaultPlaceholder>
            <skeleton-image [width]="200" [height]="200" borderRadius="4"></skeleton-image>
          </ng-template>
        </ng-template>
      </div>

    </div>
    <input #avatarUploader type="file" accept="image/*"
           (change)="imageSelected($event)" class="hide"/>

    <div class="actions flex-center-x-y">
      <button test-id="btnUploadImage"
              class="btn-link m-x-sm"
              [disabled]="!isUploadEnabled"
              [class]="isUploadEnabled? 'text-primary': 'text-muted btn-link--disabled'"
              (click)="avatarUploader.click()">
        <i class="fa fa-light fa-upload" aria-hidden="true"></i>{{ 'COMMON.upload' | translate }}
      </button>

      <button test-id="btnDeleteImage"
              class="btn-link m-x-sm"
              [disabled]="!isDeleteEnabled"
              [class]="isDeleteEnabled? 'text-primary': 'text-muted btn-link--disabled'"
              (click)="deleteImage()">
        <i class="fa fa-light fa-trash-alt" aria-hidden="true"></i>
        {{ 'FORMS.delete' | translate }}
      </button>
    </div>
  </div>
  <div class="gp-modal-footer flex-between">
    <ul class="error-list" [attr.data-hidden]="!maxSizeError">
      <li>{{ maxSizeError }}</li>
    </ul>

    <ul class="error-list" [attr.data-hidden]="!fileFormatError">
      <li>{{ fileFormatError }}</li>
    </ul>
    <div class="btn-bar-wrapper flex-1">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="button"
                class="btn btn-dark p-x-md"
                [disabled]="!isSubmitEnabled"
                (click)="onSubmit()">
          {{ 'FORMS.submit' | translate }}
          <em *ngIf="isOperationInProgress" class="fa fa-light fa-spinner fa-spin"></em>
        </button>
        <button type="button" class="btn btn-secondary p-x-md"
                [disabled]="isOperationInProgress"
            (click)="onCancel(imageUploadModal)">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
